import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {FormattedMessage} from 'react-intl'

type Props = {
  heading?: string
}

export function HowItWorks({heading}: Props) {
  const intl = useIntl()
  return (
    <section className='how-it-works overflow-x-hidden'>
      <div className='container d-flex flex-column align-items-flex-start'>
        <div className='d-flex flex-column w-100 align-items-flex-start align-self-stretch head-container'>
          <h2 className='text-left lh-sm'>{intl.formatMessage({id: 'HOW_IT_WORKS'})}</h2>
          <p className='mb-0 pretendard how-it-works-sub'>
            {intl.formatMessage({id: 'HOW_IT_WORKS_SUB'})}
          </p>
        </div>
        <div className='d-flex w-100 flex-column flex-md-row justify-content-between align-items-start'>
          <div className='step'>
            <img
              src={toAbsoluteUrl('/media/gori/landing/import-icon.svg')}
              alt='import orders icon'
            />
            <p className='numbered'>{intl.formatMessage({id: 'HOW_IT_WORKS_STEPS_1'})}</p>
            <p className='description'>
              <FormattedMessage
                id='HOW_IT_WORKS_STEPS_1_DESC'
                values={{
                  store: <strong>{heading}</strong>,
                }}
              />
            </p>
          </div>
          <div className='step'>
            <img
              src={toAbsoluteUrl('/media/gori/landing/manage-shipping-icon.svg')}
              alt='manage shipping icon'
            />
            <p className='numbered'>{intl.formatMessage({id: 'HOW_IT_WORKS_STEPS_2'})}</p>
            <p className='description'>
              <FormattedMessage
                id='HOW_IT_WORKS_STEPS_2_DESC'
                values={{
                  store: <strong>{heading}</strong>,
                }}
              />
            </p>
          </div>
          <div className='step'>
            <img
              src={toAbsoluteUrl('/media/gori/landing/print-labels-icon.svg')}
              alt='print labels icon'
            />
            <p className='numbered'>{intl.formatMessage({id: 'HOW_IT_WORKS_STEPS_3'})}</p>
            <p className='description'>{intl.formatMessage({id: 'HOW_IT_WORKS_STEPS_3_DESC'})}</p>
          </div>
          <div className='step'>
            <img
              src={toAbsoluteUrl('/media/gori/landing/track-icon.svg')}
              alt='track and update icon'
            />
            <p className='numbered'>{intl.formatMessage({id: 'HOW_IT_WORKS_STEPS_4'})}</p>
            <p className='description'>
              <FormattedMessage
                id='HOW_IT_WORKS_STEPS_4_DESC'
                values={{
                  store: <strong>{heading}</strong>,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
